module.exports = {
  PRODUCTION: "production",
  PREPROD: "pre_production",
  STAGE: "stage",
  DEVELOPMENT: "development",
};
